var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#F9818E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9251 55.4166C34.4624 55.312 34.9965 55.1918 35.5267 55.056C36.4261 54.8052 37.3124 54.5097 38.1823 54.1704C39.0541 53.833 39.9084 53.4521 40.7422 53.0293C41.5756 52.6046 42.3874 52.1384 43.1742 51.6325C43.9599 51.1276 44.7198 50.5837 45.4512 50.0029C46.1843 49.4208 46.8879 48.8023 47.5593 48.1497C48.2288 47.4987 48.8653 46.8147 49.4666 46.1002C50.0693 45.3849 50.6358 44.64 51.164 43.8681C51.6917 43.0972 52.1805 42.3005 52.6287 41.4808C53.0766 40.6602 53.4832 39.8178 53.847 38.9566C54.2117 38.0953 54.533 37.2162 54.8098 36.3228C55.0466 35.5408 55.2491 34.7488 55.4167 33.9492L38.7618 17.2883C35.7918 14.3172 31.9134 12.8333 28.0297 12.8333C24.1458 12.8333 20.2585 14.317 17.2885 17.2883C11.3483 23.2306 11.3483 32.8317 17.2885 38.774L33.9251 55.4166Z",
    fill: "#E96170"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7196 17.2789C35.7549 14.3141 31.8792 12.8333 28.0023 12.8333C24.1254 12.8333 20.2451 14.3141 17.2804 17.2789C11.351 23.2087 11.351 32.7895 17.2804 38.7193C23.2098 44.649 32.7902 44.649 38.7196 38.7193C44.6491 32.7895 44.6491 23.2087 38.7196 17.2789ZM34.297 23.5739C34.4719 23.4376 34.6865 23.3528 34.9073 23.3325C34.9468 23.3305 34.9863 23.3305 35.0257 23.3325C35.9967 23.3464 36.4804 24.87 35.6953 25.4415L26.3672 32.4379C25.923 32.7694 25.2381 32.7202 24.8459 32.3286L20.1818 27.6643C19.2895 26.8076 20.9739 25.1231 21.8306 26.0154L25.7796 29.9646L34.297 23.5739Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/success-check.fe614f538abfa681029de822fe0b9573.svg";
export { ForwardRef as ReactComponent };